import React, { useState, useContext, useEffect } from "react";
import "../../../css/AddCustomer.css";
import DeleteConfirmationModal from "../DeleteConfirmationModal";
import axios from "axios";
import { BankNameContext } from "../../../context/BankNameContext";
import CustomAlert from "../../../helpers/CustomAlert";
import { toast } from "react-toastify";
import {apiList, baseAuthUrl} from "../../../helpers/apiList";
import { axiosGetApi } from "../../../helpers/interceptorServices";
import AadhaarInput from "../../common/AadhaarInput";

const AddCustomer = ({
  show,
  handleClose,
  editData,
  action,
  fetchCustomerData,
  payloadData,
  setPayloadData,
  loggedInUserName,
  CloseCreate,
  handleNext,
  minSmsRate,
  minRcsRate,
  minRcsUtlRate,
}) => {
  // const loggedInUserName = sessionStorage.getItem("username");

  const [errors, setErrors] = useState({
    name: "",
    emailId: "",
    address1: "",
    address2: "",
    pinCode: "",
    firstContactPersonName: "",
    firstContactPersonMobileNo: "",
    // secondContactPersonName: '',
    // secondContactPersonMobileNo: '',
    bankName: "",
    accountNo: "",
    ifscCode: "",
    rate: "",
    rcsRate: "",
    rcsUtlRate: "",
    waMarketingRate: "",
    waUtilityRate: "",
    waAuthenticationRate: "",
    gstNumber: "",
    aadharNumber: "",
    panNumber: "",
    companyPanNumber: "",
    companyType: "",
  });
  const { bankNames, loading, error } = useContext(BankNameContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [validGSTNo, setValidGSTNo] = useState(false);
  const [validCompanyPanNo, setValidCompanyPanNo] = useState(false);
  const [services, setServices] = useState({
    smsServices: true,
    rcsServices: false,
    waServices: false,
  });

  useEffect(() => {
    if (!payloadData) return;

    // Avoid triggering setState if not needed
    if (
      !payloadData.rcsServices &&
      (payloadData.rcsRate !== "" || payloadData.rcsUtlRate !== "")
    ) {
      setPayloadData((prev) => ({
        ...prev,
        rcsRate: "",
        rcsUtlRate: "",
      }));
      setErrors((prev) => ({ ...prev, rcsRate: "", rcsUtlRate: "" }));
    }

    if (
      !payloadData.smsServices &&
      (payloadData.rate !== "" || payloadData.smsRatePro !== "")
    ) {
      setPayloadData((prev) => ({
        ...prev,
        rate: "",
        smsRatePro: "",
      }));
      setErrors((prev) => ({ ...prev, rate: "" }));
    }

    if (
      !payloadData.waServices &&
      (payloadData.waMarketingRate !== "" || payloadData.waUtilityRate !== "" || payloadData.waAuthenticationRate !== "")
    ) {
      setPayloadData((prev) => ({
        ...prev,
        waMarketingRate: "",
        waUtilityRate: "",
        waAuthenticationRate: "",
      }));
      setErrors((prev) => ({
        ...prev,
        waMarketingRate: "",
        waUtilityRate: "",
        waAuthenticationRate: "",
      }));
    }
  }, [payloadData, setPayloadData]);

  if (loading) {
    return <p>Loading data...</p>;
  }

  if (error) {
    return <p>Error fetching data: {error}</p>;
  }

  const handleServiceChange = (e) => {
    const { name, checked } = e.target;
    setServices((prev) => ({ ...prev, [name]: checked }));
    setPayloadData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    if (
      id === "name" ||
      id === "ifscCode" ||
      id === "gstNumber" ||
      id === "panNumber" ||
      id === "companyPanNumber"
    ) {
      updatedValue = value.toUpperCase();
    } else if (id === "emailId") {
      updatedValue = value.toLowerCase();
    } else if (
      id === "firstContactPersonMobileNo" ||
      id === "secondContactPersonMobileNo" ||
      id === "accountNo"
    ) {
      updatedValue = value.replace(/[^0-9]/g, "");
    }

    setPayloadData((prev) => {
      const newPayload = { ...prev, [id]: updatedValue };

      if (id === "gstNumber") {
        if (updatedValue.length === 15) {
          const derivedPan = updatedValue.slice(2, 12);
          newPayload.companyPanNumber = derivedPan;
        } else {
          newPayload.companyPanNumber = "";
        }
      }

      return newPayload;
    });

    if (id === "pinCode") {
      validatePinCode(value);
    }

    if (id === "companyType") {
      const trimmedValue = updatedValue.trim();
      const isValidAuthPerPan =
        trimmedValue === "Private Limited" ||
        trimmedValue === "Public Limited" ||
        trimmedValue === "LLP";

      setErrors((prevErrors) => ({
        ...prevErrors,
        panNumber:
          isValidAuthPerPan &&
            payloadData?.companyPanNumber === payloadData?.panNumber
            ? "Company PAN and Authorised PAN must be different"
            : "",
      }));
    }
  };

  const handleNextWithValidation = () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    // If there are no validation errors, proceed to next step
    if (
      Object.keys(validationErrors).length === 0 ||
      action === "view" ||
      action === "delete" ||
      action === "auth" ||
      (action === "modify" && !payloadData.aadharNumberRaw)
    ) {
      handleNext(); // Call the original handleNext function
    } else {
      // Show error message or toast notification
      toast.error("Please fix all validation errors before proceeding", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      // Scroll to first error field
      const firstErrorField = document.querySelector(".error");
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  // Simple validation function
  const validate = () => {
    const newErrors = {};

    // Name validation (between 2 and 50 characters)
    payloadData.name = payloadData.name.trim();
    if (!payloadData.name) {
      newErrors.name = "Company Name is required";
    } else if (
      // !/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(payloadData.name) ||
      !/^[A-Za-z0-9@&.,'\- ]+$/.test(payloadData.name) ||
      payloadData.name.length < 2 ||
      payloadData.name.length > 50
    ) {
      newErrors.name =
        "Company name must be valid and between 2 and 50 characters";
    } else if (/^(.)\1{2,}$/.test(payloadData.name)) {
      newErrors.name =
        "Company name cannot be made of a single repeated character";
    }

    // Email validation (required and valid email)
    if (!payloadData.emailId) {
      newErrors.emailId = "Email is required";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(
        payloadData.emailId,
      ) ||
      /\.com\./.test(payloadData.emailId) ||
      /\.co\.[a-zA-Z]{2}\./.test(payloadData.emailId)
    ) {
      newErrors.emailId = "Enter valid email ending with .com .co.xx or .in";
    }

    // Address validation
    payloadData.address1 = payloadData.address1.trim();
    if (!payloadData.address1) {
      newErrors.address1 = "Address is required";
    } else if (
      payloadData.address1.length < 5 ||
      payloadData.address1.length > 150
    ) {
      newErrors.address1 = "Address1 must be between 5 and 150 characters";
    } else if (
      !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
        payloadData.address1,
      )
    ) {
      newErrors.address1 =
        "Address 1 contains invalid characters or starts/ends with spaces";
    } else if (!/[A-Za-z]/.test(payloadData.address1)) {
      newErrors.address1 = "Address 1 must contain at least one letter";
    }

    // Address 2 validation (required)
    payloadData.address2 = payloadData.address2.trim();
    if (!payloadData.address2) {
      newErrors.address2 = "Address is required";
    } else if (
      payloadData.address2.length < 5 ||
      payloadData.address2.length > 150
    ) {
      newErrors.address2 = "Address2 must be between 5 and 50 characters";
    } else if (
      !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
        payloadData.address2,
      )
    ) {
      newErrors.address2 =
        "Address 2 contains invalid characters or starts/ends with spaces";
    } else if (!/[A-Za-z]/.test(payloadData.address2)) {
      newErrors.address2 = "Address 2 must contain at least one letter";
    }

    // Address 3 validation (optional)
    payloadData.address3 = payloadData.address3.trim();
    if (payloadData.address3) {
      if (
        payloadData.address3.length < 5 ||
        payloadData.address3.length > 150
      ) {
        newErrors.address3 = "Address 3 must be between 5 and 150 characters";
      } else if (
        !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
          payloadData.address3,
        )
      ) {
        newErrors.address3 =
          "Address 3 contains invalid characters or starts/ends with spaces";
      } else if (!/[A-Za-z]/.test(payloadData.address3)) {
        newErrors.address3 = "Address 3 must contain at least one letter";
      }
    }
    if (!payloadData.pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^[1-9]\d{5}$/.test(payloadData.pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits and must not start with 0";
    }

    // First contact person name validation (between 2 and 50 characters)
    payloadData.firstContactPersonName =
      payloadData.firstContactPersonName.trim();
    if (!payloadData.firstContactPersonName) {
      newErrors.firstContactPersonName = "Contact person name is required";
    } else if (
      !/^[A-Za-z@&.,'\- ]+$/.test(payloadData.firstContactPersonName) ||
      payloadData.firstContactPersonName.length < 2 ||
      payloadData.firstContactPersonName.length > 50
    ) {
      newErrors.firstContactPersonName =
        "Contact person name must be between 2 and 50 characters and contain only letters";
    } else if (
      !/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(payloadData.firstContactPersonName)
    ) {
      newErrors.firstContactPersonName =
        "Contact person name must contain only letters, spaces, dots, or hyphens and cannot start or end with spaces or symbols";
    } else if (
      /^([A-Za-z])\1+$/.test(
        payloadData.firstContactPersonName.replace(/[ .-]/g, ""),
      )
    ) {
      newErrors.firstContactPersonName =
        "Contact person name cannot consist of the same letter repeated";
    }

    // First contact person mobile number validation
    if (!payloadData.firstContactPersonMobileNo) {
      newErrors.firstContactPersonMobileNo =
        "Contact person mobile number is required";
    } else if (!/^[6789]\d{9}$/.test(payloadData.firstContactPersonMobileNo)) {
      newErrors.firstContactPersonMobileNo =
        "Mobile number must be 10 digits and start with 6, 7, 8, or 9";
    } else if (/^(\d)\1{9}$/.test(payloadData.firstContactPersonMobileNo)) {
      newErrors.firstContactPersonMobileNo =
        "Mobile number cannot have all repeated digits";
    } else if (
      payloadData.firstContactPersonMobileNo === "1234567890" ||
      payloadData.firstContactPersonMobileNo === "9876543210"
    ) {
      newErrors.firstContactPersonMobileNo =
        "Mobile number cannot be a simple sequence";
    }

    // Bank Name validation
    if (!payloadData.bankName) {
      newErrors.bankName = "Bank Name is required";
    }

    // IFSC Code validation (must be 11 characters)
    if (!payloadData.ifscCode) {
      newErrors.ifscCode = "IFSC code is required";
    } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(payloadData.ifscCode)) {
      newErrors.ifscCode =
        "Invalid IFSC Code. It must be 4 alphabets, followed by 0, and 6 alphanumeric characters (e.g., IDIB000L123)";
    }

    // GST Number Validation
    if (!payloadData.gstNumber) {
      newErrors.gstNumber = "GST Number is required";
    } else if (
      !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
        payloadData.gstNumber,
      )
    ) {
      newErrors.gstNumber = "Invalid GST Number format";
    }

    // Aadhar Number Validation
    const aadharRaw = payloadData.aadharNumberRaw?.trim() || "";
    if (!aadharRaw) {
      newErrors.aadharNumber = "Aadhar Number is required";
    } else if (!/^[2-9]\d{11}$/.test(aadharRaw)) {
      newErrors.aadharNumber =
        "Aadhar Number must be exactly 12 digits and start with 2-9";
    } else if (/^(\d)\1{11}$/.test(aadharRaw)) {
      newErrors.aadharNumber = "Aadhar Number cannot have all repeated digits";
    }

    // PAN Number Validation
    if (!payloadData.panNumber) {
      newErrors.panNumber = "PAN Number is required";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(payloadData.panNumber)) {
      newErrors.panNumber = "Invalid PAN Number format";
    }

    // Company PAN Number Validation
    if (!payloadData.companyPanNumber) {
      newErrors.companyPanNumber = "PAN Number is required";
    } else if (
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(payloadData.companyPanNumber)
    ) {
      newErrors.companyPanNumber = "Invalid PAN Number format";
    }

    // Rate validation (at least one of SMS Rate or RCS Rate is required)
    if (
      !payloadData.rate &&
      !payloadData.rcsRate &&
      services?.smsServices &&
      services?.rcsServices
    ) {
      newErrors.rate = "At least one of SMS Rate or RCS Rate is required";
      newErrors.rcsRate = "At least one of SMS Rate or RCS Rate is required";
    } else {
      if (
        payloadData.rate &&
        !/^(?:[1-9][0-9]?)(?:\.[0-9]{1,2})?$/.test(
          payloadData.rate.toString().trim(),
        )
      ) {
        newErrors.rate = "SMS Rate value must be between 1.00 to 99.00";
      } else if (payloadData?.smsServices && !payloadData.rate) {
        newErrors.rate = "SMS Rate is required";
      } else if (
        payloadData.rate &&
        minSmsRate &&
        Number(payloadData.rate) < Number(minSmsRate)
      ) {
        newErrors.rate = `SMS Rate cannot be lower than ${minSmsRate}`;
      }
      if (
        payloadData.rcsRate &&
        !/^(?:[1-9][0-9]?)(?:\.[0-9]{1,2})?$/.test(
          payloadData.rcsRate.toString().trim(),
        )
      ) {
        newErrors.rcsRate = "RCS Rate value must be between 1.00 to 99.00";
      } else if (payloadData?.rcsServices && !payloadData.rcsRate) {
        newErrors.rcsRate = "RCS Rate is required";
      } else if (
        payloadData.rcsRate &&
        minRcsRate &&
        Number(payloadData.rcsRate) < Number(minRcsRate)
      ) {
        newErrors.rcsRate = `RCS Rate cannot be lower than ${minRcsRate}`;
      }
    }

    // RCS Utility Rate validation
    if (
      payloadData.rcsUtlRate &&
      !/^(?:[1-9][0-9]?)(?:\.[0-9]{1,2})?$/.test(
        payloadData.rcsUtlRate.toString().trim(),
      )
    ) {
      newErrors.rcsUtlRate =
        "RCS Utility Rate value must be between 1.00 to 99.00";
    } else if (payloadData?.rcsServices && !payloadData.rcsUtlRate) {
      newErrors.rcsUtlRate = "RCS Utility Rate is required";
    } else if (
      payloadData.rcsUtlRate &&
      minRcsUtlRate &&
      Number(payloadData.rcsUtlRate) < Number(minRcsUtlRate)
    ) {
      newErrors.rcsUtlRate = `RCS Utility Rate cannot be lower than ${minRcsUtlRate}`;
    }

    // WhatsApp Rate validation
    if (payloadData?.waServices) {
      if (!payloadData.waMarketingRate) {
        newErrors.waMarketingRate = "WhatsApp Marketing Rate is required";
      } else {
        if (!/^\d+(?:\.\d+)?$/.test(payloadData.waMarketingRate.toString().trim())) {
          newErrors.waMarketingRate = "Please enter a valid number.";
        }
      }

      if (!payloadData.waUtilityRate) {
        newErrors.waUtilityRate = "WhatsApp Utility Rate is required";
      } else {
        if (!/^\d+(?:\.\d+)?$/.test(payloadData.waUtilityRate.toString().trim())) {
          newErrors.waUtilityRate = "Please enter a valid number.";
        }
      }

      if (!payloadData.waAuthenticationRate) {
        newErrors.waAuthenticationRate = "WhatsApp Authentication Rate is required";
      } else {
        if (!/^\d+(?:\.\d+)?$/.test(payloadData.waAuthenticationRate.toString().trim())) {
          newErrors.waAuthenticationRate = "Please enter a valid number.";
        }
      }
    }

    // Account Number validation (between digits 5 to 30)
    if (!payloadData.accountNo) {
      newErrors.accountNo = "Account Number is required";
    } else if (!/^\d{9,18}$/.test(payloadData.accountNo)) {
      newErrors.accountNo = "Account Number must be 9 to 18 digits";
    } else if (/^(\d)\1{8,17}$/.test(payloadData.accountNo)) {
      newErrors.accountNo = "Account Number cannot have all repeated digits";
    }

    // Company Type validation
    if (!payloadData.companyType) {
      newErrors.companyType = "Company Type is required";
    }

    return newErrors;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const fieldErrors = {};
    const trimmedValue = value.trim();

    switch (id) {
      case "name":
        if (!trimmedValue) {
          fieldErrors.name = "Company Name is required";
        } else if (
          !/^[A-Za-z0-9@&.,'\- ]+$/.test(trimmedValue) ||
          trimmedValue.length < 2 ||
          trimmedValue.length > 50
        ) {
          fieldErrors.name =
            "Company name must be valid and between 2 and 50 characters";
        } else if (/^(.)\1{2,}$/.test(trimmedValue)) {
          fieldErrors.name =
            "Company name cannot be made of a single repeated character";
        } else {
          fieldErrors.name = ""; // ✅ Clear error if valid
        }
        break;

      case "emailId":
        if (!trimmedValue) {
          fieldErrors.emailId = "Email is required";
        } else if (
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(
            trimmedValue,
          ) ||
          /\.com\./.test(trimmedValue) ||
          /\.co\.[a-zA-Z]{2}\./.test(trimmedValue)
        ) {
          fieldErrors.emailId =
            "Enter valid email ending with .com .co.xx or .in";
        } else {
          fieldErrors.emailId = "";
        }
        break;

      case "address1":
        if (!trimmedValue) {
          fieldErrors.address1 = "Address is required";
        } else if (trimmedValue.length < 5 || trimmedValue.length > 150) {
          fieldErrors.address1 =
            "Address 1 must be between 5 and 150 characters";
        } else if (
          !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
            trimmedValue,
          )
        ) {
          fieldErrors.address1 =
            "Address 1 contains invalid characters or starts/ends with spaces";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.address1 = "Address 1 must contain at least one letter";
        } else {
          fieldErrors.address1 = "";
        }
        break;

      case "address2":
        if (!trimmedValue) {
          fieldErrors.address2 = "Address is required";
        } else if (trimmedValue.length < 5 || trimmedValue.length > 150) {
          fieldErrors.address2 =
            "Address 2 must be between 5 and 150 characters";
        } else if (
          !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
            trimmedValue,
          )
        ) {
          fieldErrors.address2 =
            "Address 2 contains invalid characters or starts/ends with spaces";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.address2 = "Address 2 must contain at least one letter";
        } else {
          fieldErrors.address2 = "";
        }
        break;

      case "address3":
        if (trimmedValue) {
          if (trimmedValue.length < 5 || trimmedValue.length > 150) {
            fieldErrors.address3 =
              "Address 3 must be between 5 and 150 characters";
          } else if (
            !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
              trimmedValue,
            )
          ) {
            fieldErrors.address3 =
              "Address 3 contains invalid characters or starts/ends with spaces";
          } else if (!/[A-Za-z]/.test(trimmedValue)) {
            fieldErrors.address3 = "Address 3 must contain at least one letter";
          } else {
            fieldErrors.address3 = "";
          }
        } else {
          fieldErrors.address3 = "";
        }
        break;

      case "pinCode":
        if (!trimmedValue) {
          fieldErrors.pinCode = "Pincode is required";
        } else if (!/^[1-9]\d{5}$/.test(trimmedValue)) {
          fieldErrors.pinCode =
            "Pincode must be 6 digits and must not start with 0";
        } else {
          fieldErrors.pinCode = "";
        }
        break;

      case "firstContactPersonName":
        if (!trimmedValue) {
          fieldErrors.firstContactPersonName =
            "Contact person name is required";
        } else if (
          // !/^[A-Za-z@&.,'\- ]+$/.test(payloadData.firstContactPersonName) ||
          trimmedValue.length < 2 ||
          trimmedValue.length > 50
        ) {
          fieldErrors.firstContactPersonName =
            "Contact person name must be between 2 and 50 characters";
        } else if (!/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(trimmedValue)) {
          fieldErrors.firstContactPersonName =
            "Contact person name must contain only letters, spaces, dots, or hyphens and cannot start or end with spaces or symbols";
        } else if (/^([A-Za-z])\1+$/.test(trimmedValue.replace(/[ .-]/g, ""))) {
          fieldErrors.firstContactPersonName =
            "Contact person name cannot consist of the same letter repeated";
        } else {
          fieldErrors.firstContactPersonName = "";
        }
        break;

      case "firstContactPersonMobileNo":
        if (!trimmedValue) {
          fieldErrors.firstContactPersonMobileNo =
            "Contact person mobile number is required";
        } else if (!/^[6789]\d{9}$/.test(trimmedValue)) {
          fieldErrors.firstContactPersonMobileNo =
            "Mobile number must be 10 digits and start with 6, 7, 8, or 9";
        } else if (/^(\d)\1{9}$/.test(trimmedValue)) {
          fieldErrors.firstContactPersonMobileNo =
            "Mobile number cannot have all repeated digits";
        } else if (
          trimmedValue === "1234567890" ||
          trimmedValue === "9876543210"
        ) {
          fieldErrors.firstContactPersonMobileNo =
            "Mobile number cannot be a simple sequence";
        } else {
          fieldErrors.firstContactPersonMobileNo = "";
        }
        break;

      case "bankName":
        if (!trimmedValue) {
          fieldErrors.bankName = "Bank Name is required";
        } else {
          fieldErrors.bankName = "";
        }
        break;

      case "ifscCode":
        if (!trimmedValue) {
          fieldErrors.ifscCode = "IFSC code is required";
        } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(trimmedValue)) {
          fieldErrors.ifscCode =
            "Invalid IFSC Code. Format: 4 letters, 0, followed by 6 alphanumeric characters (e.g., IDIB000L123)";
        } else {
          fieldErrors.ifscCode = "";
        }
        break;

      case "gstNumber":
        if (!trimmedValue) {
          fieldErrors.gstNumber = "GST Number is required";
        } else if (
          !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
            trimmedValue,
          )
        ) {
          fieldErrors.gstNumber = "Invalid GST Number format";
        } else {
          fieldErrors.gstNumber = "";
          if (trimmedValue.length === 15) {
            const derivedPan = trimmedValue.slice(2, 12);
            setPayloadData((prev) => ({
              ...prev,
              companyPanNumber: derivedPan,
            }));
          }
        }
        break;

      case "aadharNumber":
        const aadharRaw = payloadData.aadharNumberRaw?.trim() || "";

        if (!aadharRaw) {
          fieldErrors.aadharNumber = "Aadhar Number is required";
        } else if (!/^[2-9]\d{11}$/.test(aadharRaw)) {
          fieldErrors.aadharNumber =
            "Aadhar Number must be exactly 12 digits and start with 2-9";
        } else if (/^(\d)\1{11}$/.test(aadharRaw)) {
          fieldErrors.aadharNumber =
            "Aadhar Number cannot have all repeated digits";
        } else {
          fieldErrors.aadharNumber = "";
        }
        break;

      case "panNumber":
        if (!trimmedValue) {
          fieldErrors.panNumber = "PAN Number is required";
        } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(trimmedValue)) {
          fieldErrors.panNumber = "Invalid PAN Number format";
        } else if (
          isValidAuthPerPan &&
          payloadData?.companyPanNumber === trimmedValue
        ) {
          fieldErrors.panNumber =
            "Company PAN and Authorised PAN must be different";
        } else {
          fieldErrors.panNumber = "";
        }
        break;

      case "rate":
      case "rcsRate":
        const rateValue = payloadData.rate?.toString().trim();
        const rcsRateValue = payloadData.rcsRate?.toString().trim();

        if (
          !rateValue &&
          !rcsRateValue &&
          payloadData?.smsServices &&
          payloadData?.rcsServices
        ) {
          fieldErrors.rate = "At least one of SMS Rate or RCS Rate is required";
          fieldErrors.rcsRate =
            "At least one of SMS Rate or RCS Rate is required";
        } else {
          if (
            rateValue &&
            !/^(?:[1-9][0-9]?)(?:\.[0-9]{1,2})?$/.test(
              rateValue.toString().trim(),
            ) &&
            payloadData?.smsServices
          ) {
            fieldErrors.rate = "SMS Rate value must be between 1.00 to 99.00";
          } else if (payloadData?.smsServices && !rateValue) {
            fieldErrors.rate = "SMS Rate is required";
          } else if (
            rateValue &&
            minSmsRate &&
            Number(rateValue) < Number(minSmsRate)
          ) {
            fieldErrors.rate = `SMS Rate cannot be lower than ${minSmsRate}`;
          } else {
            fieldErrors.rate = "";
          }
          if (
            rcsRateValue &&
            !/^(?:[1-9][0-9]?)(?:\.[0-9]{1,2})?$/.test(
              rcsRateValue.toString().trim(),
            )
          ) {
            fieldErrors.rcsRate =
              "RCS Rate value must be between 1.00 to 99.00";
          } else if (payloadData?.rcsServices && !rcsRateValue) {
            fieldErrors.rcsRate = "RCS Rate is required";
          } else if (
            rcsRateValue &&
            minRcsRate &&
            Number(rcsRateValue) < Number(minRcsRate)
          ) {
            fieldErrors.rcsRate = `RCS Rate cannot be lower than ${minRcsRate}`;
          } else {
            fieldErrors.rcsRate = "";
          }
        }
        break;

      case "rcsUtlRate":
        if (
          trimmedValue &&
          !/^(?:[1-9][0-9]?)(?:\.[0-9]{1,2})?$/.test(trimmedValue)
        ) {
          fieldErrors.rcsUtlRate =
            "RCS Utility Rate value must be between 1.00 to 99.00";
        } else if (payloadData?.rcsServices && !trimmedValue) {
          fieldErrors.rcsUtlRate = "RCS Utility Rate is required";
        } else if (
          trimmedValue &&
          minRcsUtlRate &&
          Number(trimmedValue) < Number(minRcsUtlRate)
        ) {
          fieldErrors.rcsUtlRate = `RCS Utility Rate cannot be lower than ${minRcsUtlRate}`;
        } else {
          fieldErrors.rcsUtlRate = "";
        }
        break;

      case "waMarketingRate":
        if (payloadData?.waServices) {
          if (!trimmedValue) {
            fieldErrors.waMarketingRate = "WhatsApp Marketing Rate is required";
          } else if (!/^\d+(?:\.\d+)?$/.test(trimmedValue)) {
            fieldErrors.waMarketingRate = "Please enter a valid number.";
          } else {
            fieldErrors.waMarketingRate = "";
          }
        }
        break;

      case "waUtilityRate":
        if (payloadData?.waServices) {
          if (!trimmedValue) {
            fieldErrors.waUtilityRate = "WhatsApp Utility Rate is required";
          } else if (!/^\d+(?:\.\d+)?$/.test(trimmedValue)) {
            fieldErrors.waUtilityRate = "Please enter a valid number.";
          } else {
            fieldErrors.waUtilityRate = "";
          }
        }
        break;

      case "waAuthenticationRate":
        if (payloadData?.waServices) {
          if (!trimmedValue) {
            fieldErrors.waAuthenticationRate = "WhatsApp Authentication Rate is required";
          } else if (!/^\d+(?:\.\d+)?$/.test(trimmedValue)) {
            fieldErrors.waAuthenticationRate = "Please enter a valid number.";
          } else {
            fieldErrors.waAuthenticationRate = "";
          }
        }
        break;

      case "accountNo":
        if (!trimmedValue) {
          fieldErrors.accountNo = "Account Number is required";
        } else if (!/^\d{9,18}$/.test(trimmedValue)) {
          fieldErrors.accountNo = "Account Number must be 9 to 18 digits";
        } else if (/^(\d)\1{8,17}$/.test(trimmedValue)) {
          fieldErrors.accountNo =
            "Account Number cannot have all repeated digits";
        } else {
          fieldErrors.accountNo = "";
        }
        break;

      case "companyType":
        if (!trimmedValue) {
          fieldErrors.companyType = "Company Type is required";
        } else {
          fieldErrors.companyType = "";
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));
  };

  const validatePinCode = (pinCode) => {
    let newErrors = { ...errors };

    if (!pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^\d{6}$/.test(pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits";
    } else {
      delete newErrors.pinCode;

      axios
        .get(`${baseAuthUrl}/sms/pincode/${pinCode}`)
        .then((response) => {
          const { status, message, data } = response.data;

          if (!status || !data || data.length === 0) {
            newErrors.pinCode = message || "Enter a valid Pincode";
          } else {
            const pinCodeData = data[0];
            const { cityName, state } = pinCodeData;
            setPayloadData((prevFormData) => ({
              ...prevFormData,
              city: cityName,
              state,
            }));

            delete newErrors.pinCode;
          }
          setErrors(newErrors);
        })
        .catch((error) => {
          newErrors.pinCode = "Error fetching pincode data";
          setErrors(newErrors);
        });
    }
  };

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";
  const isAuthMode = action === "auth";

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleCheckGstNumber = async () => {
    const gstNumber = payloadData?.gstNumber;

    if (!gstNumber || gstNumber.length !== 15) {
      CustomAlert({
        title: "Invalid GST",
        text: "Please enter a valid 15-digit GST Number.",
        icon: "warning",
        confirmButtonText: "Okay",
      });
      return;
    }

    try {
      const response = await axiosGetApi(
        `${apiList.GET_GST_STATUS}/${gstNumber}`,
      );

      const respCode = response?.data?.respCode;

      if (response?.data?.status && respCode === "00") {
        CustomAlert({
          title: response?.data?.message,
          // text: response?.data?.message || "GST Number exists.",
          icon: "info",
          confirmButtonText: "Retry",
        });
        setValidGSTNo(false);
      } else if (respCode === "01") {
        CustomAlert({
          title: "Valid GST",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        setValidGSTNo(true);
      } else {
        CustomAlert({
          title: "Error",
          text: response?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
        setValidGSTNo(false);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while checking GST number.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleCheckConpanyPanNumber = async () => {
    const companyPanNumber = payloadData?.companyPanNumber;

    if (!companyPanNumber || companyPanNumber.length !== 10) {
      CustomAlert({
        title: "Invalid PAN",
        text: "Please enter a valid 10-digit PAN Number.",
        icon: "warning",
        confirmButtonText: "Okay",
      });
      return;
    }

    try {
      const response = await axiosGetApi(
        `${apiList.GET_COMPANY_PAN_STATUS}/${companyPanNumber}`,
      );

      const respCode = response?.data?.respCode;

      if (response?.data?.status && respCode === "00") {
        CustomAlert({
          title: response?.data?.message,
          // text: response?.data?.message || "GST Number exists.",
          icon: "info",
          confirmButtonText: "Retry",
        });
        setValidCompanyPanNo(false);
      } else if (respCode === "01") {
        CustomAlert({
          title: "Valid",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        setValidCompanyPanNo(true);
      } else {
        CustomAlert({
          title: "Error",
          text: response?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
        setValidCompanyPanNo(false);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while checking Company Pan number.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const hasService =
    payloadData?.smsServices ||
    payloadData?.rcsServices ||
    payloadData?.waServices;

  const fieldDisabled =
    ((validGSTNo && validCompanyPanNo) || isEditMode) && hasService;

  const isValidAuthPerPan =
    payloadData?.companyType === "Private Limited" ||
    payloadData?.companyType === "Public Limited" ||
    payloadData?.companyType === "LLP";

  return (
    <>
      <form>
        <div className="scoped-modal modal-body">
          {["view", "auth", "modify", "delete"].includes(action) && (
            <div className="row mb-3">
              <div className="col-12 text-center">
                <h5>Company Id - {payloadData.customerCode}</h5>
              </div>
            </div>
          )}

          <div
            className="row mb-3"
            style={{ display: "flex", alignItems: "center" }}
          >
            <label
              htmlFor="gstNumber"
              className="!ml-0"
              style={{ width: "165px", fontSize: "15px" }}
            >
              Services Required<span style={{ color: "red" }}>*</span>
            </label>
            <div className="col-md-3">
              <div className="form-check flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  id="smsService"
                  name="smsServices"
                  checked={payloadData.smsServices}
                  onChange={handleServiceChange}
                  disabled={isViewMode || isDeleteMode || isAuthMode}
                />
                <label
                  className="form-check-label text-base"
                  htmlFor="smsService"
                >
                  SMS Service
                </label>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-check flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  id="rcsService"
                  name="rcsServices"
                  checked={payloadData.rcsServices}
                  onChange={handleServiceChange}
                  disabled={isViewMode || isDeleteMode || isAuthMode}
                />
                <label
                  className="form-check-label text-base"
                  htmlFor="rcsService"
                >
                  RCS Service
                </label>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <div className="form-group">
                <label
                  htmlFor="gstNumber"
                  className="!ml-0"
                  style={{ fontSize: "15px" }}
                >
                  GST Number<span style={{ color: "red" }}>*</span>
                </label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="relative" style={{ flex: 1 }}>
                    <i className="fa fa-receipt absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                    <input
                      type="text"
                      className="form-control !h-[40px] pl-9 pr-3"
                      placeholder="GST Number"
                      id="gstNumber"
                      value={payloadData.gstNumber}
                      disabled={
                        isViewMode || isDeleteMode || isAuthMode || isEditMode
                      }
                      maxLength={15}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  <button
                    type="button"
                    onClick={handleCheckGstNumber}
                    className="btn btn-submit !rounded-lg"
                    style={{
                      marginLeft: "8px",
                      height: "40px",
                      whiteSpace: "nowrap",
                    }}
                    disabled={action !== "add"}
                  >
                    check
                  </button>
                </div>
                <div style={{ minHeight: "0px" }}>
                  {!(isViewMode || isDeleteMode || isAuthMode || isEditMode) &&
                    errors.gstNumber ? (
                    <span className="error">{errors.gstNumber}</span>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label
                  htmlFor="companyPanNumber"
                  className="!ml-0"
                  style={{ fontSize: "15px" }}
                >
                  Company PAN No<span style={{ color: "red" }}>*</span>
                </label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="relative" style={{ flex: 1 }}>
                    <i className="fa fa-id-card absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                    <input
                      type="text"
                      className="form-control !h-[40px] pl-9 pr-3"
                      placeholder="Company PAN No"
                      id="companyPanNumber"
                      value={payloadData.companyPanNumber}
                      disabled={isViewMode || isDeleteMode || isAuthMode}
                      maxLength={10}
                      style={{ cursor: "not-allowed" }}
                      readOnly
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-submit !rounded-lg"
                    style={{
                      marginLeft: "8px",
                      height: "40px",
                      whiteSpace: "nowrap",
                    }}
                    onClick={handleCheckConpanyPanNumber}
                    disabled={action !== "add"}
                  >
                    check
                  </button>
                </div>
                {/* <div style={{ minHeight: "20px" }} /> */}
              </div>
            </div>
          </div>
          <hr className="mb-2" />
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="name" className="!ml-0 text-[14px]">
                  Company Name<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-building absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="Enter Company Name"
                    id="name"
                    value={payloadData.name}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) && errors.name ? (
                  <span className="error">{errors.name}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="emailId" className="!ml-0 text-[14px]">
                  Company Email Id<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-envelope absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="email"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="Enter Company Email Id"
                    id="emailId"
                    value={payloadData.emailId}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.emailId ? (
                  <span className="error">{errors.emailId}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="address1" className="!ml-0 text-[14px]">
                  Address 1<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-map-marker-alt absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="Address 1"
                    id="address1"
                    value={payloadData.address1}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.address1 ? (
                  <span className="error">{errors.address1}</span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="address2" className="!ml-0 text-[14px]">
                  Address 2<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-map-marker-alt absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="Address 2"
                    id="address2"
                    value={payloadData.address2}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.address2 ? (
                  <span className="error">{errors.address2}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="address3" className="!ml-0 text-[14px]">
                  Address 3
                </label>
                <div className="relative">
                  <i className="fa fa-map-marker-alt absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="Address 3"
                    id="address3"
                    value={payloadData.address3}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="pinCode" className="!ml-0 text-[14px]">
                  Pin Code<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-location-dot absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="Pin Code"
                    id="pinCode"
                    value={payloadData.pinCode}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={6}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,6}$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.pinCode ? (
                  <span className="error">{errors.pinCode}</span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="state" className="!ml-0 text-[14px]">
                  State
                </label>
                <div className="relative">
                  <i className="fa fa-flag absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    id="state"
                    value={payloadData.state || "State"}
                    style={{ cursor: "not-allowed" }}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="city" className="!ml-0 text-[14px]">
                  City
                </label>
                <div className="relative">
                  <i className="fa fa-city absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    id="city"
                    value={payloadData.city || "City"}
                    style={{ cursor: "not-allowed" }}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="firstContactPersonName"
                  className="!ml-0 text-[14px]"
                >
                  Contact Person Name
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-user absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="Contact Person Name"
                    id="firstContactPersonName"
                    value={payloadData.firstContactPersonName}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={50}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[A-Za-z .-]*$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.firstContactPersonName ? (
                  <span className="error">{errors.firstContactPersonName}</span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="firstContactPersonMobileNo"
                  className="!ml-0 text-[14px]"
                >
                  Contact Person Mobile No.
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-phone absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="Contact Person Mobile No."
                    id="firstContactPersonMobileNo"
                    value={payloadData.firstContactPersonMobileNo}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Only allow digits and max 10 characters
                      if (/^\d{0,10}$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                  />
                </div>

                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.firstContactPersonMobileNo ? (
                  <span className="error">
                    {errors.firstContactPersonMobileNo}
                  </span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="companyType" className="!ml-0 text-[14px]">
                  Company Type<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-sitemap absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <select
                    id="companyType"
                    className="form-select !h-[40px] pl-9 pr-3"
                    value={payloadData.companyType}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    style={{ appearance: "listbox" }}
                  >
                    <option value="">Select Type</option>
                    <option value="Proprietor">Proprietor</option>
                    <option value="Private Limited">Private Limited</option>
                    <option value="Individual">Individual</option>
                    <option value="LLP">LLP</option>
                    <option value="Public Limited">Public Limited</option>
                    <option value="Partnership">Partnership</option>
                  </select>
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.companyType ? (
                  <span className="error">{errors.companyType}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="bankName" className="!ml-0 text-[14px]">
                  Bank Name<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-university absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <select
                    id="bankName"
                    className="form-select !h-[40px] pl-9 pr-3"
                    value={payloadData.bankName}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    style={{ appearance: "listbox" }}
                  >
                    <option value="">Select Bank</option>
                    {bankNames?.map((bank) => (
                      <option key={bank.bankId} value={bank.bankName}>
                        {bank.bankName}
                      </option>
                    ))}
                  </select>
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.bankName ? (
                  <span className="error">{errors.bankName}</span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="accountNo" className="!ml-0 text-[14px]">
                  Account Number<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-credit-card absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="Account Number"
                    id="accountNo"
                    value={payloadData.accountNo}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={18}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,18}$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.accountNo ? (
                  <span className="error">{errors.accountNo}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="ifscCode" className="!ml-0 text-[14px]">
                  IFSC Code<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-exchange-alt absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="IFSC Code"
                    id="ifscCode"
                    value={payloadData.ifscCode}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.ifscCode ? (
                  <span className="error">{errors.ifscCode}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="panNumber" className="!ml-0 text-[14px]">
                  Authorize Person PAN No<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-id-card absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="Authorize Person PAN No"
                    id="panNumber"
                    value={payloadData.panNumber}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={10}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.panNumber ? (
                  <span className="error">{errors.panNumber}</span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="aadharNumber" className="!ml-0 text-[14px]">
                  Aadhar Number<span style={{ color: "red" }}>*</span>
                </label>

                <div className="relative">
                  <i className="fa fa-id-badge absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <AadhaarInput
                    id="aadharNumber"
                    value={payloadData.aadharNumber}
                    onChange={(masked, raw) => {
                      setPayloadData((prev) => ({
                        ...prev,
                        aadharNumber: masked, // for display
                        aadharNumberRaw: raw, // for validation
                      }));
                    }}
                    onBlur={handleBlur}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    className="!h-[40px] pl-9 pr-3"
                    error={
                      !(
                        isViewMode ||
                        isDeleteMode ||
                        isAuthMode ||
                        (action === "modify" && !payloadData.aadharNumberRaw)
                      ) && errors.aadharNumber
                        ? errors.aadharNumber
                        : null
                    }
                  />
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="smsRatePro" className="!ml-0 text-[14px]">
                  SMS Rate (Promotional)<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-comment absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="0.00"
                    id="smsRatePro"
                    value={payloadData.smsRatePro}
                    disabled={
                      isViewMode ||
                      isDeleteMode ||
                      isAuthMode ||
                      !fieldDisabled ||
                      (payloadData?.rcsServices && !payloadData?.smsServices)
                    }
                    style={{
                      textAlign: "right",
                    }}
                    maxLength={10}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.smsRatePro ? (
                  <span className="error">{errors.smsRatePro}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="rate" className="!ml-0 text-[14px]">
                  SMS Rate (Transactional){" "}
                  <span style={{ color: "black" }}>(in paisa)</span>
                  {!payloadData.rcsRate ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : null}
                  {minSmsRate ? (
                    <span style={{ color: "#6c757d" }}> (Min: {minSmsRate})</span>
                  ) : null}
                </label>
                <div className="relative">
                  <i className="fa fa-comment absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="0.00"
                    id="rate"
                    value={
                      isViewMode || isDeleteMode || isAuthMode
                        ? Number(payloadData.rate).toFixed(2)
                        : payloadData.rate
                    }
                    disabled={
                      isViewMode ||
                      isDeleteMode ||
                      isAuthMode ||
                      !fieldDisabled ||
                      (payloadData?.rcsServices && !payloadData?.smsServices)
                    }
                    style={{
                      textAlign: "right",
                    }}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) && errors.rate ? (
                  <span className="error">{errors.rate}</span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="rcsRate" className="!ml-0 text-[14px]">
                  RCS Rate (Promotional){" "}
                  <span style={{ color: "black" }}>(in paisa)</span>
                  {!payloadData.rate ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : null}
                  {minRcsRate ? (
                    <span style={{ color: "#6c757d" }}> (Min: {minRcsRate})</span>
                  ) : null}
                </label>
                <div className="relative">
                  <i className="fa fa-comments absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="0.00"
                    id="rcsRate"
                    value={
                      isViewMode || isDeleteMode || isAuthMode
                        ? Number(payloadData.rcsRate).toFixed(2)
                        : payloadData.rcsRate
                    }
                    disabled={
                      isViewMode ||
                      isDeleteMode ||
                      isAuthMode ||
                      !fieldDisabled ||
                      (payloadData?.smsServices && !payloadData?.rcsServices)
                    }
                    style={{
                      textAlign: "right",
                    }}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.rcsRate ? (
                  <span className="error">{errors.rcsRate}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="rcsUtlRate" className="!ml-0 text-[14px]">
                  RCS Rate (Utility){" "}
                  <span style={{ color: "black" }}>(in paisa)</span>
                  {payloadData?.rcsServices ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : null}
                  {minRcsUtlRate ? (
                    <span style={{ color: "#6c757d" }}>
                      {" "}
                      (Min: {minRcsUtlRate})
                    </span>
                  ) : null}
                </label>
                <div className="relative">
                  <i className="fa fa-comments absolute left-3 top-1/2 -translate-y-1/2 text-[#00b6ce] text-sm pointer-events-none"></i>
                  <input
                    type="text"
                    className="form-control !h-[40px] pl-9 pr-3"
                    placeholder="0.00"
                    id="rcsUtlRate"
                    value={
                      isViewMode || isDeleteMode || isAuthMode
                        ? Number(payloadData.rcsUtlRate).toFixed(2)
                        : payloadData.rcsUtlRate
                    }
                    disabled={
                      isViewMode ||
                      isDeleteMode ||
                      isAuthMode ||
                      !fieldDisabled ||
                      (payloadData?.smsServices && !payloadData?.rcsServices)
                    }
                    style={{
                      textAlign: "right",
                    }}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                  errors.rcsUtlRate ? (
                  <span className="error">{errors.rcsUtlRate}</span>
                ) : null}
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
        <div className="scoped-modal modal-footer justify-center">
          <button
            type="button"
            className="btn btn-back !rounded-lg !w-[133px]"
            onClick={CloseCreate}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleNextWithValidation}
            className="btn btn-submit !rounded-lg !w-[133px]"
            disabled={!fieldDisabled && action === "add"}
          >
            Next
          </button>
          <DeleteConfirmationModal
            isOpen={isModalOpen}
            onClose={closeModal}
            editData={editData}
            fetchCustomerData={fetchCustomerData}
            handleClose={handleClose}
          />
        </div>
      </form>
    </>
  );
};

export default AddCustomer;
